// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"4f5cf4de","515":"2a1555f6","588":"f8b619fe","593":"fe627e6c","797":"1209425e"}[chunkId] + ".chunk.js";
};